import React from 'react';
import { styled } from '@mui/material';

const StyledBackgroundImageContainer = styled('div')(({ theme }) => ({
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f7f6ff',
    [theme.breakpoints.down(850)]: {
        padding: '44px',
    },
}));

const StyledBackgroundImage = styled('img')({
    maxWidth: '100%',
    maxHeight: '100vh',
});

type BackgroundImageProps = {
    src: string;
};

const BackgroundImage = ({ src }: BackgroundImageProps): JSX.Element => {
    return (
        <StyledBackgroundImageContainer>
            <StyledBackgroundImage src={src} />
        </StyledBackgroundImageContainer>
    );
};

export default BackgroundImage;
